import { get, curry, isArray, map, extend } from 'lodash';

export function createUser(profile, cb) {
  return simpleIsoFetch => dispatch => {
    return simpleIsoFetch.post({
      route: '/api/admin/employees',
      body: profile,
    })
    .then(({body: {data: {items: employees}}}) => employees)
    .then((resp) => {

      if(cb) {
        return cb(null, resp);
      }
      return resp;
    })
    .catch(err => {
      if(cb) {
        return cb(err);
      }
      return Promise.reject(err);
    });
  };
}

 export function updateUser(id, profile, cb) {
  return simpleIsoFetch => dispatch => {
    return simpleIsoFetch.put({
      route: `/api/admin/employees/${id}`,
      body: profile,
    })
    .then(({body: {data: {items: employees}}}) => employees)
    .then((resp) => {

      if(cb) {
        return cb(null, resp);
      }
      return resp;
    })
    .catch(err => {
      if(cb) {
        return cb(err);
      }
      return Promise.reject(err);
    });
  };
}

export function getUsers(query, cb) {
  return simpleIsoFetch => dispatch => {
    return simpleIsoFetch.get({
      route: '/api/admin/employees',
      query,
    })
    .then(({body: {data: {items: employees}}}) => employees)
    .then((resp) => {

      if(cb) {
        return cb(null, resp);
      }
      return resp;
    })
    .catch(err => {
      if(cb) {
        return cb(err);
      }
      return Promise.reject(err);
    });
  };
}

export function getUsersByRole(roleName, cb) {
  return simpleIsoFetch => dispatch => {
    return simpleIsoFetch.get({
      route: '/api/admin/employees',
      query: {
        roleName
      }
    })
    .then(({body: {data: {items: employees}}}) => employees)
    .then((resp) => {
      resp = map(resp, e => extend({name: `${e.firstName} ${e.lastName}`}, e));
      if(cb) {
        return cb(null, resp);
      }
      return resp;
    })
    .catch(err => {
      if(cb) {
        return cb(err);
      }
      return Promise.reject(err);
    });
  };
}

export function getUsersById(id, cb) {
  return simpleIsoFetch => dispatch => {
    return simpleIsoFetch.get({
      route: '/api/admin/employees',
      query: {
        id
      }
    })
    .then(({body: {data: {items: employee}}}) => isArray(employee) ? employee[0]: undefined)
    .then((resp) => {
      if(cb) {
        return cb(null, resp);
      }
      return resp;
    })
    .catch(err => {
      if(cb) {
        return cb(err);
      }
      return Promise.reject(err);
    });
  };
}

export function addRole(body, callback) {
  return simpleIsoFetch => dispatch => {
    return simpleIsoFetch.post({
      route: `/api/admin/employees/${body.userId}/role`,
      body
  })
  .then((resp) => {
    if(callback)
      return callback(null, resp.body.data.items);

    return resp.body.data.items;
  }, (err) => {
    if(callback)
      return callback(err)

    return err;
  })
    .catch(err => {
        if (!err || !~[400].indexOf(err.status)) {
          console.log(err);
        return err;
      }
    });
  };
}

export function removeRole(body, callback) {
  return simpleIsoFetch => dispatch => {
    return simpleIsoFetch.del({
      route: `/api/admin/employees/${body.userId}/role`,
      body
  })
  .then((resp) => {
    if(callback)
      return callback(null, resp.body.data.items);

    return resp.body.data.items;
  }, (err) => {
    if(callback)
      return callback(err)

    return err;
  })
    .catch(err => {
        if (!err || !~[400].indexOf(err.status)) {
          console.log(err);
        return err;
      }
    });
  };
}


export function getPins(callback) {
  return simpleIsoFetch => dispatch => {
    return simpleIsoFetch.get({
      route: '/api/admin/pins'
    })
    .then(({body: {data: {items: respData}}}) => isArray(respData) ? respData[0]: undefined)
    .then((resp) => {
      if(callback) {
        return callback(null, resp);
      }
      return resp;
    })
    .catch(err => {
      if(callback) {
        return callback(err);
      }
      return Promise.reject(err);
    });
  };
}

export function updatePins(body, callback) {
  return simpleIsoFetch => dispatch => {
    return simpleIsoFetch.put({
      route: '/api/admin/pins',
      body
    })
    .then(({body: {data: {items: respData}}}) => isArray(respData) ? respData[0]: undefined)
    .then((resp) => {
      if(callback) {
        return callback(null, resp);
      }
      return resp;
    })
    .catch(err => {
      if(callback) {
        return callback(err);
      }
      return Promise.reject(err);
    });
  };
}



// WEBPACK FOOTER //
// ./shared/redux/actionCreators/async/employees.js